import { createMuiTheme } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';


export const colors = {
  primaryRed: '#830000',
  primaryGold: '#caab0e',
  darkGrey: '#323232',
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: colors.primaryGold,
    },
    secondary: {
      main: colors.primaryRed,
    },
  },
  typography: {
    h1: {
      fontFamily: 'Galada',
    },
    h2: {
      fontFamily: 'Galada',
    },
    h3: {
      fontFamily: 'Galada',
    },
    h4: {
      fontFamily: 'Galada',
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        // backgroundColor: fade('#261e1e', 0.75),
        borderBottom: `1px solid ${fade(colors.primaryGold, 0.6)}`,
        // marginBottom: -20,
      },
    },
    // MuiDialogContent: {
    //   root: {
    //     paddingTop: 20,
    //     paddingBottom: 20,
    //   },
    // },
    MuiDialogTitle: {
      root: {
        padding: '5px 10px 5px 20px',
        // backgroundColor: colors.primaryGold,
        backgroundColor: 'black',
        color: colors.primaryGold,
        // color: 'white',
      },
    },
    MuiDialog: {
      paper: {
        border: `2px inset ${colors.primaryGold}`,
      }
    },
    MuiDrawer: {
      paper: {
        borderLeft: `1px solid ${colors.primaryGold}`,
        backgroundColor: '#1d1d1d',
        color: 'white',
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 16,
        border: `1px solid ${colors.primaryGold}`,
      },
    },
  }
});

export default theme;
